<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_club_applications')"
                        :isNewButton="checkPermission('studentclubpresidentapplication_store')"
                        :isFilter="false"
                        @new-button-click="createFormShow">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_club_applications')"
                              :isNewButton="checkPermission('studentclubpresidentapplication_store')"
                              :isFilter="false"
                              @new-button-click="createFormShow">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="checkPermission('studentclubpresidentapplication_excelexport')"
                              @exportExcel="downloadExcel">
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('club_name')">
                            <student-club-selectbox v-model="datatable.queryParams.filter.student_club_id" @club-selected="handleClubSelection"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="datatable.queryParams.filter.academic_year" />
                        </b-form-group>
                    </b-col>
                     <b-col sm="12" md="6">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="datatable.queryParams.filter.status" code="student_club_president_application_statuses"></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclubpresidentapplication_show')">
                <template v-slot:CommonModalTitle>
                    {{ $t('show').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <show-form :formId="formId"
                               v-if="formProcess=='show'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclubpresidentapplication_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclubpresidentapplication_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout.vue';
    import Header from '@/layouts/AppLayout/Header.vue'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile.vue'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter.vue';
    import Datatable from '@/components/datatable/Datatable.vue';
    import CommonModal from '@/components/elements/CommonModal.vue';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox.vue';
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";

    //Page
    import CreateForm from './CreateForm.vue'
    import UpdateForm from './UpdateForm.vue'
    import ShowForm from './ShowForm.vue'

    //Service
    import StudentClubService from '@/services/StudentClubService';

    //Other
    import qs from 'qs';
    import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";
    import router from "@/plugins/Router";
    import StudentProgramService from "@/services/StudentProgramService";

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            ParameterSelectbox,
            StudentClubSelectbox,

            CreateForm,
            UpdateForm,
            ShowForm,
        },
        metaInfo() {
            return {
                title: this.$t('student_club_applications')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                selectedPresident: '',
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('show'),
                                    class: 'ri-search-eye-line',
                                    permission: 'studentclubpresidentapplication_show',
                                    callback: (row) => {
                                        this.showForm(row.id);
                                    }
                                },
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'studentclubpresidentapplication_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('members'),
                                    class: 'ri-team-line',
                                    permission: 'studentclubpresidentapplicationuser_index',
                                    callback: (row) => {
                                        this.$router.push('/student/club/president/application/users/' + row.id);
                                    }
                                },
                                {
                                    text: this.$t('create_a_vote'),
                                    class: 'ri-chat-poll-line',
                                    permission: 'studentclubpresidentapplication_publishvote',
                                    callback: (row) => {
                                        this.createVote(row.id);
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'studentclubpresidentapplication_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.$t("club_name"),
                            field: "student_club_name",
                            hidden: false,
                            sortable: false,
                        },
                        {
                            label: this.$t("academic_year"),
                            field: "academic_year",
                            hidden: false,
                            sortable: false,
                        },
                        {
                            label: this.$t("start_date"),
                            field: "start_date",
                            hidden: false,
                            sortable: true,
                        },
                        {
                            label: this.$t("end_date"),
                            field: "end_date",
                            hidden: false,
                            sortable: false,
                        },
                        {
                            label: this.$t("status"),
                            field: "status",
                            formatFn: (row) => {
                                if (row === 'active') {
                                    return this.$t('active');
                                } else if (row === 'passive') {
                                    return this.$t('passive');
                                } else {
                                    return '';
                                }
                            },
                            hidden: false,
                            sortable: false,
                        }
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.selectedPresident = '';
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return StudentClubService.getAllPresident(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData() {
                this.formProcess = 'update';
                StudentClubService.getPresident(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            createVote(id) {
                StudentClubService.createAVote(id)
                    .then((response) => {
                        this.$toast.success(this.$t('proccess_success'));
                    })
                    .catch(err => this.showErrors(err))
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            delete(id) {
                this.deleteModal(() => {
                    StudentClubService.delPresident(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },

            handleClubSelection(clubData) {
                if (clubData && clubData.dues) {
                    this.form.dues = parseFloat(clubData.dues)
                } else {
                    this.form.dues = 0;
                }
            },

            downloadExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                StudentClubService.downloadAsExcelPresidentClubApplication(config)
                    .then(res => this._downloadFile(res, this.$t('student_club_applications') + '.xlsx'))
                    .catch(err => this.showErrors(err))
            },
        }
    }
</script>
